/* AOA homepage v5: rails (ported from homepage-redesign/round4/mockup.html).
   A live progress line under each rail, and arrow pads on desktop. No libraries.
   It runs under reduced motion too (it is position feedback, not decoration). Without JS the rails still swipe and the line
   is hidden (each aoa-v5 section adds the html class "aoa5-js" inline, so the line and pads appear without a layout shift).
   Several sections load this file with defer; it initialises once, then every [data-a5-rail] on the page, and again
   when the theme editor (re)loads a section. */
(function () {
  'use strict';
  if (window.aoa5Rails) { window.aoa5Rails.initAll(document); return; }
  document.documentElement.classList.add('aoa5-js');
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(box) {
    if (!box || box.__aoa5Rail) return;
    var tr = box.querySelector('.a5-rail');
    if (!tr) return;
    box.__aoa5Rail = true;
    var bar = box.querySelector('.a5-prog i'), pads = box.querySelectorAll('.a5-pad'), q = false;
    function upd() {
      q = false;
      if (!tr.isConnected) { window.removeEventListener('resize', req); return; }
      var w = tr.scrollWidth, v = tr.clientWidth;
      // very wide screens: when every card is already on screen, the end padding alone would still let the rail scroll
      // into empty space, so lock it at the start and hide the progress line + arrows (.a5-fits). Layout offsets, not
      // getBoundingClientRect, so the scroll-driven scale on the slides cannot fake a fit.
      var last = tr.lastElementChild;
      var fits = !!last && last.offsetParent === tr && last.offsetLeft + last.offsetWidth <= v + 1;
      if (fits !== box.__aoa5Fits) { box.__aoa5Fits = fits; box.classList.toggle('a5-fits', fits); if (fits) tr.scrollLeft = 0; }
      var p = w > v ? (tr.scrollLeft + v) / w : 1;
      if (bar) bar.style.transform = 'scaleX(' + Math.min(1, p).toFixed(3) + ')';
      // aria-disabled, not disabled: a disabled button drops keyboard focus at the end of the rail
      if (pads.length > 1) { pads[0].setAttribute('aria-disabled', tr.scrollLeft < 8); pads[1].setAttribute('aria-disabled', tr.scrollLeft > w - v - 8); }
    }
    function req() { if (!q) { q = true; window.requestAnimationFrame(upd); } }
    Array.prototype.forEach.call(pads, function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        tr.scrollBy({ left: +b.getAttribute('data-dir') * tr.clientWidth * 0.75, behavior: rm.matches ? 'auto' : 'smooth' });
      });
    });
    tr.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    upd();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-a5-rail]'), init);
  }

  window.aoa5Rails = { init: init, initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  // theme editor: selecting a card or slide that is off-screen in a rail scrolls it into view
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target && e.target.closest && e.target.closest('.a5-rail')) e.target.scrollIntoView({ inline: 'start', block: 'nearest' });
  });
})();
